// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fcd030e6","455":"71a0e215","879":"9bb56b5b","977":"bdae3324"}[chunkId] + ".chunk.js";
};